module.exports = __webpack_public_path__ + "static/media/1026444.e9deb0b3.jpg";